import React, {useContext} from 'react'

const PipelineCustomEditorContext = React.createContext()

export function usePipelineInstanceCustomEditor(pipelineType) {

    const c = useContext(PipelineCustomEditorContext)

    if(!c) {
        return null
    }

    const e = c.customRenderers[pipelineType]

    if(!e) {
        const knownTypes = Object.keys(c.customRenderers).join(',')
        throw Error(`unknown pipeline type ${pipelineType}, known types are: ${knownTypes}`)
    }

    return e
}


export const PipelineInstanceCustomEditorProvider = ({children, customRenderers}) => {
    return <PipelineCustomEditorContext.Provider value={{customRenderers}}>
        {children}
    </PipelineCustomEditorContext.Provider>
}